import { useTranslation } from "react-i18next"

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"

type ImageReasoningWarningModalProps = {
  open: boolean
  onClose: () => void
  onCancel: () => void
}

export function ImageReasoningWarningModal({
  open,
  onClose,
  onCancel,
}: ImageReasoningWarningModalProps) {
  const { t } = useTranslation()

  return (
    <AlertDialog open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="text-destructive">
            {t("pages.common.image_reasoning_warning.title")}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {t("pages.common.image_reasoning_warning.description")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel}>{t("pages.common.cancel")}</AlertDialogCancel>
          <AlertDialogAction onClick={onClose}>{t("pages.common.continue")}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
